import React, { Component } from "react";
import styles from "./Header.module.scss";
import * as icons from "./icons";

class MenuItem extends Component {
  render() {
    const { href, icon, className = "", children } = this.props;
    const Icon = icons[icon];

    return (
      <li className={`${styles.socialLinks} ${className}`}>
        <a href={href && href}>
          <Icon />
        </a>
        {children}
      </li>
    );
  }
}

export default MenuItem;
